import ShippingOptionsCustomerTable, {
  CrmReceiverCustomer,
} from '../ShippingOptionsCustomerTable';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';
import CrmCustomerListFilter, {
  CrmFilterFormValues,
} from '../CustomerListFilter';
import { Button, Col, Divider, Row } from 'antd';
import AntdFeatherIcon from '@/components/_common/AntdFeatherIcon';
import { ArrowLeft, ArrowRight } from 'react-feather';
import { FormattedMessage } from 'react-intl';
import { useState } from 'react';
import {
  CrmCustomerListProps,
  RevisionItemType,
} from '@/core/domain/crm/CrmList/CrmList.types';
import { useCrmCustomerNextRevisionList } from '@/core/domain/crm/CrmList/CrmList.hooks';
import { useWindowSize } from '@/hooks';
import moment from 'moment';
import { DateFormat } from '@/utils/moment';

const CrmCustomersNextRevisionsList: React.FC<CrmCustomerListProps> = ({
  onPrev,
  CustomersSelected,
  onCustomersSelected,
  customerIds,
}) => {
  const [filter, setFilter] = useState<CrmFilterFormValues>();
  const { isMobile } = useWindowSize();

  const queryReturn = useCrmCustomerNextRevisionList({
    startDate: filter?.initialDate
      ? moment(filter?.initialDate).format(DateFormat)
      : undefined,
    endDate: filter?.finalDate
      ? moment(filter?.finalDate).format(DateFormat)
      : undefined,
    ...filter,
  });

  const items = flatInfiniteData(queryReturn?.data);

  const dataSource = items.map<CrmReceiverCustomer>(
    ({ customer, parts, services, ...vehicle }) => ({
      id: vehicle.id,
      vehicle,
      customer,
      itens: [
        ...(parts?.map((part) => ({
          ...part,
          type: RevisionItemType.Part,
        })) || []),
        ...(services?.map((service) => ({
          ...service,
          type: RevisionItemType.Service,
        })) || []),
      ],
    }),
  );

  return (
    <>
      <CrmCustomerListFilter onFilter={setFilter} />

      <Divider />

      <ShippingOptionsCustomerTable
        dataSource={dataSource}
        loading={queryReturn?.isLoading}
        CustomersSelected={CustomersSelected}
        onCustomersSelected={onCustomersSelected}
        customerIds={customerIds}
        refetch={queryReturn?.refetch}
        fetchNextPage={queryReturn?.fetchNextPage}
        hasNextPage={queryReturn?.hasNextPage}
        isFetching={queryReturn?.isFetching}
      />

      <Row gutter={[24, 24]} style={{ marginTop: 24 }} justify="end">
        <Col span={isMobile ? 24 : undefined}>
          <Button onClick={onPrev} block>
            <AntdFeatherIcon icon={<ArrowLeft />} size={12} />
            <FormattedMessage id="commons.modal.button.back" />
          </Button>
        </Col>

        <Col span={isMobile ? 24 : undefined}>
          <Button htmlType="submit" block>
            <AntdFeatherIcon icon={<ArrowRight />} size={12} />
            <span>Continuar</span>
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default CrmCustomersNextRevisionsList;
